if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
    }

    get selectedOptionValues() {
      const options = this.querySelectorAll('.m-product-option select, .m-product-option input');
      const selectedValues = new Map();

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (field.tagName.toLowerCase() === "select") {
          const selectedOption = Array.from(field.options).find(
            (opt) => opt.selected && !opt.disabled
          );
          if (selectedOption) {
            selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
          }
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio"
        ) {
          const checkedInput = field.checked ? field : null;
          if (checkedInput) {
            selectedValues.set(fieldName, checkedInput.dataset.optionValueId);
          }
        }
      });

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (!selectedValues.has(fieldName)) {
          if (field.tagName.toLowerCase() === "select") {
            const firstValidOption = Array.from(field.options).find(
              (opt) => !opt.disabled
            );
            if (firstValidOption) {
              selectedValues.set(
                fieldName,
                firstValidOption.dataset.optionValueId
              );
            }
          } else if (
            field.tagName.toLowerCase() === "input" &&
            field.type === "radio"
          ) {
            const firstInput = field;
            if (firstInput) {
              selectedValues.set(fieldName, firstInput.dataset.optionValueId);
            }
          }
        }
      });

      const result = [];
      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;
        if (selectedValues.has(fieldName)) {
          const optionValueId = selectedValues.get(fieldName);
          if (optionValueId && !result.includes(optionValueId)) {
            result.push(optionValueId);
          }
        }
      });
      return result;
    }

    connectedCallback() {
      this.fillVariantPhotos();
      this.addEventListener('change', (event) => {
        const target = this.getInputForEventTarget(event.target);
        MinimogEvents.emit(MinimogTheme.pubSubEvents.optionValueSelectionChange, { data: { selectedOptionValues: this.selectedOptionValues, event, target } });
      });
    }

    fillVariantPhotos() {
      const emptyThumbs = this.querySelectorAll(
        ".m-product-option--node__label--photo:not(:has(img)), a.m-product-option--sibling:not(:has(img))"
      );
      if (!emptyThumbs.length) return;

      let src = "";
      const variantNode = this.querySelector("[data-selected-variant]");
      if (variantNode) {
        try {
          const variant = JSON.parse(variantNode.textContent);
          src =
            variant?.featured_image?.src ||
            variant?.featured_media?.preview_image?.src ||
            variant?.featured_media?.src ||
            "";
        } catch (error) {
          src = "";
        }
      }

      if (!src) {
        const galleryImg = document.querySelector(
          ".m-product-media img, .m-product-media--item img, .m-main-product--media img"
        );
        src = galleryImg?.currentSrc || galleryImg?.src || "";
      }

      if (!src) return;

      const thumbSrc = src.includes("?") ? `${src}&width=240` : `${src}?width=240`;
      emptyThumbs.forEach((thumb) => {
        const img = document.createElement("img");
        img.src = thumbSrc;
        img.alt = "";
        img.loading = "eager";
        img.fetchPriority = "high";
        thumb.prepend(img);
      });
    }

    getInputForEventTarget(target) {
      return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
    }
  }
  customElements.define("variant-picker", VariantPicker);
}